import React from 'react';
import GameCard from '../components/GameCard';
import './games.css';

const sampleGames = [
  {
    id: 1,
    title: 'StickBox',
    description: 'Kill, parkour, create, have fun!',
    icon: '/stickbox_icon.png',
    googleUrl: 'https://play.google.com/store/apps/details?id=com.stickman.killer.backflip',
    appleUrl: 'https://apps.apple.com/app/id6755522809'
  }
];

export default function Games() {
  return (
    <div className="games-page">
      <h1>Games</h1>
      <p className="lead">A selection of games I developed. Click the store buttons to view each listing.</p>
      <div className="games-list">
        {sampleGames.map(g => (
          <GameCard key={g.id} game={g} />
        ))}
      </div>

      <section className="socials-block" aria-labelledby="socials-title">
        <div className="socials-heading">
          <div>
            <h2 id="socials-title">Socials</h2>
          </div>
        </div>

        <div className="socials-grid">
          <a
            className="social-card youtube-card"
            href="https://www.youtube.com/@istasik"
            target="_blank"
            rel="noreferrer"
          >
            <span className="social-icon youtube-icon" aria-hidden="true">&#9654;</span>
            <span className="social-card-copy">
              <strong>YouTube</strong>
              <span>Game trailers and devlogs</span>
            </span>
            <span className="social-arrow" aria-hidden="true">&#8599;</span>
          </a>

          <a
            className="social-card discord-card"
            href="https://discord.gg/wtncQ2Xd58"
            target="_blank"
            rel="noreferrer"
          >
            <span className="social-icon discord-icon" aria-hidden="true"></span>
            <span className="social-card-copy">
              <strong>Discord</strong>
              <span>Join the community</span>
            </span>
            <span className="social-arrow" aria-hidden="true">&#8599;</span>
          </a>
        </div>
      </section>
    </div>
  );
}
